import React, { useEffect, useState, useRef } from "react";
import "../../App.css";
import "../../ProductServiceCard.css";
import { computeCrc } from "../../utils/CRC32";
import axios from "axios";
import { AuthKey } from "../../utils/Common";
import * as urls from "../../utils/URLConst";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../componants/Footer";
import { BiHomeAlt } from "react-icons/bi";

const ProductServiceCard = () => {
  const [product, setProduct] = useState([]);
  const [activeCategory, setActiveCategory] = useState(" ");
  const [IsLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const categoryRefs = useRef({});

  async function fetchProductServiceLink() {
    try {
      setIsLoading(true);
      const payload = {
        FLAG: "A",
      };

      const checksum = computeCrc(JSON.stringify(payload));

      await axios({
        method: "POST",
        url: urls.getProductServiceLink,
        data: payload,
        ...{
          headers: {
            "Content-Type": "application/json",
            checksum: checksum,
            Authorization: AuthKey,
          },
        },
      }).then((result) => {
        if (result.data.STATUS === "0") {
          const response = result.data.RESPONSE;
          // setProductServiceLink(response);
          setProduct(response ?? []);
        } else if (result.data.STATUS !== "0") {
          // toastNotify(result.Message, "error");
        }
      });
    } catch (error) {
      // submitErrorLogToApi(error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleScroll = () => {
    const scrollPosition = window.scrollY + 150;
    for (const [categoryName, ref] of Object.entries(categoryRefs.current)) {
      if (
        ref &&
        ref.offsetTop <= scrollPosition &&
        ref.offsetTop + ref.clientHeight > scrollPosition
      ) {
        setActiveCategory(categoryName);
      }
    }
  };

  useEffect(() => {
    fetchProductServiceLink();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleNavbarLinkClick = (categoryName) => {
    setActiveCategory(categoryName);
    const categoryRef = categoryRefs.current[categoryName];
    if (categoryRef) {
      categoryRef.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div>
        <nav
          id="navbar-example2"
          className="navbar navbar-expand-lg navbar-light shadow-sm  fixed-top"
          style={{ backgroundColor: "#59b03912" }}
        >
          <div className="container-fluid">
            <img
              src="/assets/images/logo3.png"
              alt=""
              width="200"
              height="50"
              className="d-inline-block align-text-top"
            />
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarNav">
              {product.map((item, index) => {
                return (
                  <ul className="navbar-nav" key={index}>
                    <li className="nav-item">
                      <Link
                        className={`nav-link navbar-text ps-3 ${activeCategory === item.CAT_NM ? "active" : ""
                          }`}
                        to={`#${item.CAT_NM}`}
                        aria-current="page"
                        href={item.CAT_NM}
                        activeclassname="active"
                        onClick={() => handleNavbarLinkClick(item.CAT_NM)}
                      >
                        {item.CAT_NM}
                      </Link>
                    </li>
                  </ul>
                );
              })}
            </div>

            <a className="btn save-btn d-flex justify-content-end" href="/">
              <BiHomeAlt />
              Login
            </a>
          </div>
        </nav>

        {IsLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <div className="spinner-border" role="status">
              <span className="sr-only"></span>
            </div>
          </div>
        ) : (
          <div style={{ marginTop: 100 }}>
            {product?.map((category, index) => (
              <section
                id={category.CAT_NM}
                key={index}
                ref={(ref) => (categoryRefs.current[category.CAT_NM] = ref)}
                data-bs-spy="scroll"
                data-bs-target="#navbar-example2"
                data-bs-offset="0"
                className="scrollspy-example"
                tabIndex="0"
              >
                <div
                  className="container mt-sm-3 mt-3"
                >
                  <div className="row deve_mobile_line">
                    <div className="col-lg-3 col-3">
                      <div className="position-sticky pb-lg-5 pb-3 mt-lg-0 mt-5 ps-2">
                        <div className="deve_process_icon position-sticky ">
                          <img
                            src="\assets\images\product-service-img.png"
                            alt="Products Icon"
                            className="deve_process_icon-img"
                          />
                        </div>

                        <p className="" style={{ marginTop: "-40px" }}>
                          <span className="our-servcs-hd">
                            {category.CAT_NM}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-9 Col-7 col-sm-12">
                      <div className="row">
                        {category?.DTL?.map((item, itemIndex) => (
                          <div
                            className="col-md-4 col-sm-6"
                            key={itemIndex}
                          // onClick={() =>
                          //   navigate("/inquiry-form", {
                          //     state: item,
                          //   })
                          // }
                          >
                            <Link className="text-decoration-none">
                              <div className="card shadow-lg move-on-hover product-border">
                                <img
                                  className="my-auto product-img"
                                  src={
                                    item.IMG
                                      ? item.IMG
                                      : "/assets/images/default_product_img.jpeg"
                                  }
                                  alt="Product-img"
                                  title={item.ITEM_NM}
                                />
                              </div>
                              <div className="mt-2 ms-2 contant-box-product">
                                <h6 className="mb-1 text-sm fw-semibold">{item.ITEM_NM}</h6>
                                <p className="text-dark text-sm ">
                                  {`${item.DESCRIPTION}`.slice(0, 100)}...{" "}
                                </p>
                              </div>
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            ))}
          </div>
        )}

        <div className="">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default ProductServiceCard;
